import { render, staticRenderFns } from "./PurchasingTypeForm.vue?vue&type=template&id=59effc52"
import script from "./PurchasingTypeForm.vue?vue&type=script&lang=js"
export * from "./PurchasingTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports